import React from 'react'
import { Box, Container } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

/**
 * Main page container.
 * @param props children
 */

const useStyles = makeStyles(() => ({
  pageContainer: {
    minHeight: '80vh'
  }
}))

export const PageContainer = (
  props: React.PropsWithChildren<React.ReactNode>
) => {
  const classes = useStyles()
  return (
    <Container disableGutters>
      <Box
        className={classes.pageContainer}
        display="flex"
        flexDirection="column"
      >
        {props.children}
      </Box>
    </Container>
  )
}
